module.exports = __webpack_public_path__ + "media/images/emblems/Duerrenroth-coat_of_arms-9f5e2305b8778b22a731a85723792ccf.svg";